import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HTMLTrans } from './Translations';

class ViewMorePagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastPageNumber: this.props.lastPageNumber || 1,
      currentPageNumber: this.props.currentPageNumber || 1,
      pageNumberPerPage: this.props.pageNumberPerPage || 4,
      onClick: this.props.onClick,
    };

    this.click = this.click.bind(this);
  }

  noPages() {
    return this.state.lastPageNumber === this.state.currentPageNumber;
  }

  render() {
    if (this.noPages()) {
      return null;
    }

    return (
        <div className={this.props.className}>
          <a href="#" onClick = { (e) => (this.click(e)) } >
              <HTMLTrans id = {this.props.viewMoreMessageKey || 'account.view_more'} > { this.props.viewMoreDefaultMessage || 'View More'} </HTMLTrans>
          </a>
        </div>);
  }

  click(e) {
    e.preventDefault();

    this.setState((prevState) => ({
      currentPageNumber: prevState.currentPageNumber + 1
    }), () => { this.state.onClick(this.state.currentPageNumber) });
  }
}

ViewMorePagination.propTypes = {
    lastPageNumber: PropTypes.number,
    currentPageNumber: PropTypes.number,
    pageNumberPerPage: PropTypes.number,
    onClick: PropTypes.func,
    viewMoreDefaultMessage: PropTypes.string,
    viewMoreMessageKey: PropTypes.string
  };

export default ViewMorePagination;



// WEBPACK FOOTER //
// ./src/Common/ViewMorePagination.js